import { AddressFormKeys } from 'components/AddressFormFields/constants'
import { getKeyList } from 'utils/utils'

export const AccountContactTypes = {
  ACCOUNT_REPRESENTATIVE: 'ACCOUNT_REPRESENTATIVE',
  BUSINESS_DIRECTOR: 'BUSINESS_DIRECTOR',
  BUSINESS_OWNER: 'BUSINESS_OWNER',
} as const

export const AccountContactTypesList = getKeyList(AccountContactTypes)

export const AccountContactTranslation = {
  ACCOUNT_REPRESENTATIVE: 'accountRepresentative',
  BUSINESS_DIRECTOR: 'businessDirector',
  BUSINESS_OWNER: 'businessOwner',
} as const

export const AccountContactStepKeys = {
  ACCOUNT_REPRESENTATIVE: 'accountRepresentative',
  BUSINESS_DIRECTOR: 'businessDirectors',
  BUSINESS_OWNER: 'businessOwners',
} as const

export const AccountContactErrorTypes = {
  EMPTY_CONTACTS: 'emptyContacts',
  MINIMUM_CONTROLLER: 'minimumController',
  ADD_CONTACT: 'addContact',
  UPDATE_CONTACT: 'updateContact',
  DELETE_CONTACT: 'deleteContact',
  CREATE_ID_VERIFICATION_LINK: 'createIdVerificationLink',
} as const

export const AccountContactOwnershipTypes = {
  DIRECT: 'DIRECT',
  INDIRECT: 'INDIRECT',
} as const

export const ControllerInfoKeys = {
  HOLDS_THE_RIGHT_TO_MANAGE_DIRECTORS: 'holdsTheRightToManageDirectors',
  INFLUENCES_CORPORATE_BODY_CONTROL: 'influencesCorporateBodyControl',
  CONTROLS_MANAGEMENT: 'controlsManagement',
  CONTROLS_CORPORATE_BODY: 'controlsCorporateBody',
} as const

export const ControllerInfoKeyList = getKeyList(ControllerInfoKeys)

export const FirstControllerInfoKey = ControllerInfoKeyList?.[0]

export const PersonDefaultOptions = {
  MYSELF: 'myself',
  SOMEONE_ELSE: 'someoneElse',
}

export const PersonDefaultOptionsList = Object.values(PersonDefaultOptions)

export const ControllerFormKeys = {
  ...ControllerInfoKeys,
  IS_CONTROLLER: 'isController',
} as const

export const ControllerFormKeyList = getKeyList(ControllerFormKeys)

export const AccountContactFormKeys = {
  ...AddressFormKeys,
  ...ControllerFormKeys,
  EMAIL_ADDRESS: 'emailAddress',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  DATE_OF_BIRTH: 'dateOfBirth',
  NATIONALITY: 'nationalityCountryCode',
  SECOND_NATIONALITY: 'secondNationalityCountryCode',
  PERSONAL_IDENTIFICATION_NUMBER: 'personalIdentificationNumber',
} as const

export const AccountContactFormKeyList = getKeyList(AccountContactFormKeys)
